import React, { Component } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Card,
  Input,
  message,
  Select,
  Spin,
} from "antd";
import axios from "services/axios";

const FormItem = Form.Item;
const { Option } = Select;

class BranchUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      branch: {},
      branchAreas: [],
      newCarAreas: [],
      pricingAreas: [],
      businessAreas: [],
      branchHeads: [],
      tntUsers: [],
      mobbiSupervisors: [],
      isLoading: false,
    };
  }

  componentDidMount() {
    this.fetchBranch(this.props.match.params.id);
    this.fetchAreaNewCar();
    this.fetchAreaBranch();
    this.fetchAreaPricing();
    this.fetchAreaBusiness();
    this.fetchBranchHead();
    this.fetchTNT();
    this.fetchMobbiSupervisor();
  }

  async fetchBranch(id) {
    const {
      data: { branch },
    } = await axios.get(`/admin-panel/branch/${id}`);
    this.setState({ branch });
  }

  async fetchAreaNewCar() {
    const {
      data: { areas },
    } = await axios.get(`/misc/area-new-car`);
    this.setState({ newCarAreas: areas });
  }

  async fetchAreaBranch() {
    const {
      data: { areas },
    } = await axios.get(`/misc/area-branch`);
    this.setState({ branchAreas: areas });
  }

  async fetchAreaPricing() {
    const {
      data: { areas },
    } = await axios.get(`/misc/area-pricing`);
    this.setState({ pricingAreas: areas });
  }

  async fetchAreaBusiness() {
    const {
      data: { areas },
    } = await axios.get(`/misc/area-business`);
    this.setState({ businessAreas: areas });
  }

  async fetchBranchHead() {
    const {
      data: { branch_heads },
    } = await axios.get(`/misc/branch-heads`);
    this.setState({ branchHeads: branch_heads });
  }

  async fetchTNT() {
    const {
      data: { tntUsers },
    } = await axios.get(`/misc/tnt-users`);
    this.setState({ tntUsers });
  }

  async fetchMobbiSupervisor() {
    const {
      data: { mobbiSupervisors },
    } = await axios.get(`/misc/mobbi-supervisors`);
    this.setState({ mobbiSupervisors });
  }

  async updateBranch(e) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      this.setState({ isLoading: true });
      if (!err) {
        axios
          .patch(
            `/admin-panel/branch/update/${this.props.match.params.id}`,
            values
          )
          .then(result => {
            message.success(`Berhasil Update Cabang ${values.branch}`);
            this.props.history.push(`/home/branch`);
          })
          .catch(err => {
            this.errorMessage(err);
          });
      }
      this.setState({ isLoading: false });
    });
  }

  callback(key, props) {
    props.form.resetFields();
  }

  errorMessage(e) {
    if (e.response) {
      if (e.response.data || e.response.message) {
        message.error(
          e.response.data.message || e.response.message || e.response.data
        );
      } else {
        message.error("Error Update Branch");
      }
    } else {
      message.error("Error Update Branch");
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Card title="Update Branch">
        <Spin tip="Sedang update Branch" spinning={this.state.isLoading}>
          <Form onSubmit={e => this.updateBranch(e)}>
            <FormItem label="Branch">
              {getFieldDecorator("branch", {
                initialValue: this.state.branch.partnerName,
                rules: [{ required: true, message: "Branch wajib diisi" }],
              })(<Input />)}
            </FormItem>
            <FormItem label="Branch Code">
              {getFieldDecorator("code", {
                initialValue: this.state.branch.code,
                rules: [{ required: true, message: "Branch Code wajib diisi" }],
              })(<Input />)}
            </FormItem>

            <FormItem label="Pricing Area">
              {getFieldDecorator("areaPricingId", {
                initialValue: this.state.branch
                  ? this.state.branch.areaPricingId
                  : "",
              })(
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Select a Pricing Area">
                  {this.state.pricingAreas.map((val, index) => (
                    <Option key={index} value={val.id}>
                      {val.name}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>

            <FormItem label="New Car Area">
              {getFieldDecorator("areaNewCarId", {
                initialValue: this.state.branch ? this.state.branch.areaId : "",
              })(
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Select a New Car Area">
                  {this.state.newCarAreas.map((val, index) => (
                    <Option key={index} value={val.id}>
                      {val.name}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>

            <FormItem label="Branch Area">
              {getFieldDecorator("areaBranchId", {
                initialValue: this.state.branch
                  ? this.state.branch.areaBranchId
                  : "",
              })(
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Select a Branch Area">
                  {this.state.branchAreas.map((val, index) => (
                    <Option key={index} value={val.id}>
                      {val.name}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>

            <FormItem label="Business Area">
              {getFieldDecorator("areaBusinessId", {
                initialValue: this.state.branch
                  ? this.state.branch.areaBusinessId
                  : "",
              })(
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Select a Business Area">
                  {this.state.businessAreas.map((val, index) => (
                    <Option key={index} value={val.id}>
                      {val.area}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>

            <FormItem label="Branch Head">
              {getFieldDecorator("branchHeadId", {
                initialValue: this.state.branch
                  ? this.state.branch.branchHeadId
                  : null,
              })(
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Select a Branch Head">
                  {this.state.branchHeads.map((val, index) => (
                    <Option key={index} value={val.id}>
                      {val.name}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>

            <FormItem label="TNT">
              {getFieldDecorator("tntProfileId", {
                initialValue: this.state.branch
                  ? this.state.branch.TNTProfile
                    ? this.state.branch.TNTProfile.userId
                    : null
                  : null,
              })(
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Select a TNT">
                  {this.state.tntUsers.map((val, index) => (
                    <Option key={index} value={val.userId}>
                      {val.User ? val.User.name : ""}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>

            <FormItem label="Mobbi Supervisor">
              {getFieldDecorator("mobbiSPVId", {
                initialValue: this.state.branch
                  ? this.state.branch.mobbiSPVId
                  : null,
              })(
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Select a Mobbi Supervisor">
                  {this.state.mobbiSupervisors.map((val, index) => (
                    <Option key={index} value={val.id}>
                      {val.name}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
            <Row type="flex" justify="end">
              <Col>
                <Button htmlType="submit" type="primary">
                  Update
                </Button>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Card>
    );
  }
}

export default Form.create()(BranchUpdate);



// WEBPACK FOOTER //
// src/components/Dashboard/Branch/BranchUpdate.js